<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="this.width" :height="this.height" viewBox="0 0 19 20">
    <path
      fill-rule="nonzero"
      :style="pathStyle"
      :class="pathStyle ? '' : 'default'"
      :stroke-width="strokeWidth"
      d="M13.642 12.02a6.298 6.298 0 0 0 2.218-4.771C15.86 3.787 13.098 1 9.665 1 6.233 1 3.47 3.787 3.47 7.249c0 1.9.837 3.631 2.177 4.771A8.171 8.171 0 0 0 1 18.944c0 .254.167.423.377.465a.456.456 0 0 0 .46-.38c.168-2.871 1.968-5.32 4.605-6.418.92.549 2.01.887 3.181.887 1.172 0 2.26-.338 3.182-.887a7.352 7.352 0 0 1 4.772 6.46c0 .253.209.422.46.38.251 0 .419-.211.377-.464-.167-3.04-2.01-5.7-4.772-6.967zM4.349 7.249c0-2.998 2.386-5.405 5.358-5.405 2.93 0 5.358 2.407 5.358 5.405s-2.386 5.404-5.358 5.404c-2.972 0-5.358-2.406-5.358-5.404z"
    />
  </svg>
</template>

<script>
export default {
  name: 'PeopleIcon',
  props: {
    color: {
      type: String,
      default: null
    },
    strokeWidth: {
      type: String,
      default: '.5'
    },
    width: {
      type: String,
      default: '20'
    },
    height: {
      type: String,
      default: '20'
    },
  },
  computed: {
    pathStyle() {
      if (!this.color) return ''

      return `fill: ${this.color}`
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

path {
  stroke: $primary;

  .default {
    fill: $primary;
  }
}

.topnav-icon:hover {
  cursor: pointer;
}
</style>
